(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eg-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  const injectElements = () => {
    const productGridPadding = document.querySelector('[class*="product-grid-padding"]')
    const bundleCard = document.querySelector('#eg-bundle-card')

    productGridPadding.querySelectorAll('.page-width').forEach(elem => {
      elem.classList.remove('page-width')
    })

    productGridPadding.classList.add('page-width')
    productGridPadding.insertAdjacentElement('afterbegin', bundleCard)
  }
  injectElements()
  
  const adjustProductForms = () => {  
    document.querySelectorAll('.collection product-form').forEach(productForm => {
      var newProductForm = document.createElement('eg-bundle-product-form')
      newProductForm.innerHTML = productForm.innerHTML

      productForm.parentNode.replaceChild(newProductForm, productForm)
    })
  }
  adjustProductForms()

  const adjustQuickViewContents = () => {
    document.querySelectorAll('quick-add-modal').forEach(quickAddModal => {
      const observer = new MutationObserver((mutations) => {
        setTimeout(() => {
          const productForm = quickAddModal.querySelector('product-form')
          if (!productForm) return

          var newProductForm = document.createElement('eg-bundle-product-form')
          newProductForm.innerHTML = productForm.innerHTML

          productForm.parentNode.replaceChild(newProductForm, productForm)
        }, 1000)
      })

      observer.observe(quickAddModal, { 
        attributes: true
      });
    })
  }
  adjustQuickViewContents()

  const reInitAfterAjaxLoad = () => {
    const wrapper = document.querySelector('.collection')

    const observer = new MutationObserver(async (mutations) => {
      setTimeout(() => {
        const productGridPadding = document.querySelector('[class*="product-grid-padding"]')
        
        productGridPadding.querySelectorAll('.page-width').forEach(elem => {
          elem.classList.remove('page-width')
        }) 
        
        adjustProductForms()
        reInitAfterAjaxLoad()
      }, 500)

    })

    observer.observe(wrapper, { 
      attributes: true,
      childList: true,
    });
  }
  reInitAfterAjaxLoad()

  class EgBundleProductForm extends HTMLElement {
    constructor () {
      super()

      setTimeout(() => {
        this.form = this.querySelector('form')
        this.btn = this.querySelector('button[name="add"]')
        this.quickAddModal = this.closest('.quick-add-modal')

        this.form.addEventListener('submit', this.onSubmit.bind(this))
        this.adjustBtn()
        this.handleVariantChange()
      }, 50)
    }

    adjustBtn () {
      if (!this.btn.disabled) {
        this.btn.querySelector('span').textContent = window.eg_bundle_builder.text.add_to_bundle
      }
    }

    handleVariantChange () {
      if (this.quickAddModal) {
        this.quickAddModal.querySelectorAll('variant-selects input').forEach(input => {
          input.addEventListener('change', () => {
            this.btn.style.opacity = '.1'

            setTimeout(() => {
              this.adjustBtn()
              this.btn.style.opacity = '1'
            }, 500)
          })
        })
      }
    }

    async onSubmit (event) {
      event.preventDefault()
         
      this.btn.classList.add('loading')
      this.btn.querySelector('.loading__spinner').classList.remove('hidden') 

      const variantId = Number(this.form.querySelector('[name="id"]').value)

      const bundleContents = JSON.parse(localStorage.getItem('eg-bundle-contents')) || []

      const isInBundleContents = bundleContents.some((item) => item.variant_id === variantId)

      let qty = 1

      if (this.quickAddModal) {
        const qtyFeield = this.quickAddModal.querySelector('input[name="quantity"]')

        if (qtyFeield) {
          qty = Number(qtyFeield.value)
        }
      }

      if (isInBundleContents) {
        bundleContents.map(item => {
          if (item.variant_id === variantId) {
            item.quantity += qty
          }
          return item
        })
      } else {
        let productLink 
      
        if (this.quickAddModal) {
          productLink = this.closest('.product').querySelector('a[href*="products"]').getAttribute('href') 
        } else {
          productLink = this.closest('.card').querySelector('a[href*="products"]').getAttribute('href') 
        }

        productLink = productLink.replace(/(\?.*)|(#.*)/g, "")

        const response = await fetch(`${productLink}.js`)
        const product = await response.json()
        console.log(product)

        const variant = product.variants.find(variant => variant.id === variantId)
        console.log(variant)

        bundleContents.push({
          product_id: product.id,
          product_handle: product.handle,
          product_title: product.title,
          product_image: product.featured_image,
          variant_id: variant.id,
          variant_title: variant.title,
          variant_price: variant.price, 
          variant_compare_at_price: variant.compare_at_price,
          variant_image: variant.featured_image ? variant.featured_image.src : null,
          quantity: qty
        })
      }

      console.log(bundleContents)

      localStorage.setItem('eg-bundle-contents', JSON.stringify(bundleContents))

      this.btn.querySelector('span').textContent = window.eg_bundle_builder.text.added_to_bundle
      this.btn.classList.remove('loading')
      this.btn.querySelector('.loading__spinner').classList.add('hidden') 
      
      window.dispatchEvent(new CustomEvent('eg_bundle_builder_add_to_bundle'))

      setTimeout(() => {
        this.quickAddModal?.hide()
      }, 1000)

      setTimeout(() => {
        this.btn.querySelector('span').textContent = window.eg_bundle_builder.text.add_to_bundle

        this.quickAddModal?.hide()
      }, 2000)
    }
  }
  customElements.define('eg-bundle-product-form', EgBundleProductForm)

  class EgBundleCard extends HTMLElement {
    constructor () {
      super ()
  
      this.updateContents()
      this.fixStickyPosition()

      window.addEventListener('eg_bundle_builder_add_to_bundle', () => {
        this.updateContents()
      })

      document.querySelectorAll('.eg-btn-atc').forEach(btn => {
        btn.addEventListener('click', () => {
          this.onAddToCart(btn)
        })
      })
    }

    getBundleContents () {
      return JSON.parse(localStorage.getItem('eg-bundle-contents')) || []
    }

    getTotalPrice () {
      return this.getBundleContents().reduce((accumulator, currentValue) =>
        (currentValue.variant_price * currentValue.quantity) + accumulator, 0)
    }

    updateContents () {
      const totalPrice = this.getTotalPrice()
      const progressBar = this.querySelector('.progress-bar') 
      const progressText = this.querySelector('.progress-text') 
      const tiers = window.eg_bundle_builder.tiers
      const maxTierGoal = window.eg_bundle_builder.max_tier_goal
      let progressWidth = Math.round(totalPrice / maxTierGoal * 100)

      if (progressWidth > 100) progressWidth = 100
      
      setTimeout(() => {
        progressBar.style.width = `${progressWidth}%`

        if (progressWidth >= 100) {
          progressBar.style.backgroundColor = progressBar.dataset.colorCompleted
        } else {
          progressBar.style.backgroundColor = progressBar.dataset.colorNotCompleted 
        }
      }, 200)

      if (totalPrice <= maxTierGoal) {
        const tier = tiers.find(elem => elem.goal > totalPrice)
        const remaining = this.formatMoney(tier.goal - totalPrice).replace('.00', '')
        const discount = tier.discount + '%' 
        let textUncompleted = progressText.dataset.textUncompleted
        textUncompleted = textUncompleted.replace('[value]', `<b>${remaining}</b>`)
        textUncompleted = textUncompleted.replace('[discount]', `<b>${discount}</b>`)
        progressText.innerHTML = textUncompleted
        progressText.style.color = ''
      } else {
        const discount = tiers[tiers.length - 1].discount + '%'

        let textCompleted = progressText.dataset.textCompleted
        textCompleted = textCompleted.replace('[discount]', `<b>${discount}</b>`)
        progressText.innerHTML = textCompleted
        progressText.style.color = progressBar.dataset.colorCompleted
      }

      document.querySelectorAll('[data-eg-bundle-price]').forEach(elem => {
        const tier = tiers.slice().reverse().find(elem => elem.goal <= totalPrice)

        if (tier) {
          const compareAtPrice = this.formatMoney(totalPrice)
          const price = this.formatMoney((1 - (tier.discount / 100)) * totalPrice)
          elem.innerHTML = `
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <s>${compareAtPrice}</s> 
            <span class="visually-hidden visually-hidden--inline">Sale price</span>
            <b>${price}</b>
          `
        } else {
          elem.innerHTML = this.formatMoney(totalPrice)
        }
      })

      document.querySelectorAll('[data-eg-bundle-discount]').forEach(elem => {
        const tier = tiers.slice().reverse().find(elem => elem.goal <= totalPrice)

        const tierDiscount = tier?.discount || 0

        const savings = this.formatMoney(tierDiscount / 100 * totalPrice)
        elem.innerHTML = `${savings} (${tierDiscount}%)`
      }) 

      document.querySelectorAll('.eg-btn-view-contents').forEach(elem => {
        elem.disabled = totalPrice === 0
      })

      document.querySelectorAll('.eg-btn-atc').forEach(elem => {
        elem.disabled = totalPrice === 0
      })
    } 

    async onAddToCart (btn) {
      btn.classList.add('loading')
      btn.querySelector('.loading__spinner').classList.remove('hidden') 

      const items = this.getBundleContents().reduce((accumulator, currentValue) => {
        accumulator.push({
          id: currentValue.variant_id,
          quantity: currentValue.quantity
        })
        return accumulator
      }, []) 

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      let sections = cart.getSectionsToRender().map((section) => section.id)

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items, sections })
      })
      const responseData = await response.json()

      localStorage.removeItem('eg-bundle-contents')
      this.updateContents()

      if (btn.dataset.redirectToCheckout === 'true') {
        window.location.href = '/checkout'
        return
      }

      btn.classList.remove('loading')
      btn.querySelector('.loading__spinner').classList.add('hidden')
      
      document.querySelector('#eg-bundle-dialog')?.close()
      
      cart.renderContents(responseData)
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty')
    }

    fixStickyPosition () {
      const elem = this.querySelector('.eg-inner-content')
      let oldScroll = window.scrollY

      window.addEventListener('scroll', (event) => {
        if (!document.querySelector('.shopify-section-header-sticky')) return

        const stickyType = document.querySelector('sticky-header').dataset.stickyType

        const newScroll = window.scrollY

        if (newScroll > oldScroll) {
          if (stickyType === 'always') {
            elem.style.top = 'calc(var(--header-height) + 1.5rem)'
          } else {
            elem.style.top = '1.5rem'
          }
        } else if (newScroll < oldScroll) {
          elem.style.top = 'calc(var(--header-height) + 1.5rem)'
        }

        oldScroll = Math.max(window.scrollY, 0)
      })
    }

    formatMoney (cents, moneyFormat = this.dataset.moneyFormat) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '')
      }

      let value = ''
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

      function defaultOption (opt, def) {
        return (typeof opt === 'undefined' ? def : opt)
      }

      function formatWithDelimiters (number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2)
        thousands = defaultOption(thousands, ',')
        decimal = defaultOption(decimal, '.')

        if (isNaN(number) || number == null) {
          return 0
        }

        number = (number / 100.0).toFixed(precision)

        const parts = number.split('.')
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
        const cents = parts[1] ? (decimal + parts[1]) : ''

        return dollars + cents
      }

      switch (moneyFormat.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
      }

      return moneyFormat.replace(placeholderRegex, value)
    }
  }
  customElements.define('eg-bundle-card', EgBundleCard)

  class EgBundleStickyCard extends HTMLElement {
    constructor () {
      super()

      const bundleCard = document.querySelector('#eg-bundle-card')

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.remove('show')
          } else {
            this.classList.add('show')
          }
        })
      }, { threshold: 0 })

      observer.observe(bundleCard)
    }
  }
  customElements.define('eg-bundle-sticky-card', EgBundleStickyCard)

  class EgBundleDialog extends HTMLElement {
    constructor () {
      super()

      this.dialog = this.querySelector('dialog')

      document.querySelectorAll('.eg-btn-view-contents').forEach(btn => {
        btn.addEventListener('click', () => {
          this.dialog.showModal()
          document.querySelector('body').classList.add('overflow-hidden')
        })
      })

      // Close dialog if clicked outside
      this.dialog.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(this.dialog.querySelector('.eg-dialog-inner'))

        if (!withinBoundaries) {
          this.dialog.close()
        }
      })

      this.dialog.querySelector('data-dialog-close')?.addEventListener('click', (event) => {
        event.preventDefault()
        this.dialog.close()
      })

      this.dialog.addEventListener('close', (event) => {
        document.querySelector('body').classList.remove('overflow-hidden')
      })

      this.buildContents()

      window.addEventListener('eg_bundle_builder_add_to_bundle', () => {
        this.buildContents()
      })
    }

    getBundleContents () {
      return JSON.parse(localStorage.getItem('eg-bundle-contents')) || []
    }

    buildContents () {
      const wrapper = this.querySelector('.eg-bundle-contents')
      wrapper.innerHTML = ''

      let bundleContentsList = ''

      this.getBundleContents().forEach(elem => {
        const image = elem.variant_image || elem.product_image
      
        bundleContentsList += `
          <div class="eg-bundle-contents-item" role="listitem">
            <div class="eg-bundle-contents-item-left">
              <img
                src="${this.resizeImage(image, `600x600`, 'center')}"
                class=""
                alt="${(elem.product_title || 'Product').replace(/"/g, '&quot;')}"
                width="600"
                height="600"
                loading="lazy">
            </div>
            <div class="eg-bundle-contents-item-right">
              <h3 class="title h4">
                ${elem.product_title}
              </h3>
              <p class="eg-variant-title product-option" ${elem.variant_title === 'Default Title' ? 'hidden': ''}>
                ${elem.variant_title}
              </p>
              <p class="eg-variant-price product-option">
                ${document.querySelector('#eg-bundle-card').formatMoney(elem.variant_price)}
              </p>
              <div class="eg-quantity-wrapper">
                <quantity-input class="quantity">
                  <button class="quantity__button no-js-hidden disabled" name="minus" type="button">
                    <span class="visually-hidden">Decrease quantity</span>
                    <span class="svg-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"></path></svg>
                    </span>
                  </button>
                  <input 
                    class="quantity__input" 
                    type="number"
                    value="${elem.quantity}" 
                    min="1" 
                    step="1" 
                    aria-label="Quantity"
                    data-variant-id="${elem.variant_id}"
                    onchange="document.querySelector('eg-bundle-dialog').updateItemQty(this, event)">
                  <button class="quantity__button no-js-hidden" name="plus" type="button">
                    <span class="visually-hidden">Increase quantity</span>
                    <span class="svg-wrapper">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"></path></svg>
                    </span>
                  </button>
                </quantity-input>
                <button
                  type="button" 
                  class="button button--tertiary eg-remove-btn" 
                  aria-label="Remove" 
                  data-variant-id="${elem.variant_id}"
                  onclick="document.querySelector('eg-bundle-dialog').removeItem(this, event)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false" class="icon icon-remove">
                    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ` 
      })

      wrapper.insertAdjacentHTML('afterbegin', bundleContentsList)
    }

    updateItemQty (input, event) {
      const variantId = Number(input.dataset.variantId)
      const newQty = Number(input.value)

      let bundleContents = this.getBundleContents()

      bundleContents.map(item => {
        if (item.variant_id === variantId) {
          item.quantity = newQty
        }
        return item
      })

      localStorage.setItem('eg-bundle-contents', JSON.stringify(bundleContents))
    
      this.buildContents()
      document.querySelector('#eg-bundle-card').updateContents()
    }

    removeItem (btn, event) {
      const variantId = Number(btn.dataset.variantId)

      let bundleContents = this.getBundleContents()

      bundleContents = bundleContents.filter(item => item.variant_id !== variantId)

      localStorage.setItem('eg-bundle-contents', JSON.stringify(bundleContents))
    
      this.buildContents()
      document.querySelector('#eg-bundle-card').updateContents()

      if (!bundleContents.length) {
        this.dialog.close()
      }
    }

    resizeImage = function (src, size, crop = '') {
      return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
          if (crop.length) {
            crop = `_crop_${crop}`
          }
          return `_${size}${crop}${match}`
        })
    }
  }
  customElements.define('eg-bundle-dialog', EgBundleDialog)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
